import { createFileRoute } from '@tanstack/react-router'
import ReviewSettings from '@/pages/settings/review'

export const Route = createFileRoute(
  '/(protected)/settings/review'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ReviewSettings />
}

